import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Typography,
    Box,
    Button,
    IconButton,
    Tooltip,
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { grey } from '@mui/material/colors';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Delete, Edit } from '@mui/icons-material';

const TablaEvaluaciones = ({ columnas, lineas, handleOpen, acciones = false, }) => {
    const [data, setData] = React.useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [abrir, setAbrir] = React.useState(false)

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    //abrir modal
    const openModal = (row) => {
        var id = row.original.id
        console.log(id)
        handleOpen(id)
    }
    //cerrar modal
    const handleCloseModalTable = () => {
        setAbrir(false)
    }
    //submit del formulario del modal
    const handleSubmit = (values) => {
        console.log(values);
        data.push(values);
        setData([...data]);
        // onClose();
    };

    // const handleCreateNewRow = (values) => {
    //     data.push(values);
    //     setData([...data]);
    // };

    const handleDeleteRow = useCallback(
        (row) => {
            if (
                !window.confirm(`Estas seguro que deseas eliminar este registro?`)
            ) {
                return;
            }
            // funcionEliminar(tableData[row.index])
            data.splice(row.index, 1);
            setData([...data]);
            // .then(() => {
            //     //cuando se cumpla la funcion de eliminar, se va a eliminar de la tabla
            //     tableData.splice(row.index, 1);
            //     setTableData([...tableData]);
            // })
        },
        [data],
    );

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
        data[row.index] = values;
        //send/receive api updates here, then refetch or update local table data for re-render
        setData([...data]);
        exitEditingMode(); //required to exit editing mode and close modal
    };

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                // onPaginationChange={setPagination} //hoist pagination state to your state when it changes internally
                columns={columns}
                data={data}
                // muiTableBodyProps={{
                //     sx: (theme) => ({
                //         '& tr:nth-of-type(odd)': {
                //             backgroundColor: theme.palette.primary.dark,
                //         },
                //     }),
                // }}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.primary.dark, 0.1),
                        maxWidth: '1042px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                // enableColumnResizing
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderRowActions={({
                    row
                }) => <div style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.7rem',
                    margin: '5px'
                }}>
                        <Button variant="contained" color="secondary" onClick={() => openModal(row)}>
                            Completar
                        </Button>
                    </div>} />
        </>
    )
}

export default TablaEvaluaciones